import React, { PureComponent, Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    View,
    Text,
    StyleSheet,
    Navigator,
    TextInput,
    FlatList,
    ScrollView,
    Animated
} from 'react-native';

import {
    JDTouchable,
    JDImage,
    JDText,
    JDDevice,
    JDRouter,
    JDPopupWindow,
    JDRadio,
    JDRadioGroup,
    JDScrollView,
    JDScrollTabView
} from '@jdreact/jdreact-core-lib';

import { pt, tip, is_android, format, mta } from '../../common/utils';

import st from './st_coupon';

const { ScrollTabView, ScrollTabBar, DefaultTabBar } = JDScrollTabView;

export default class Coupon extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedCoupon: this.props.coupon || [],
            labelType: 0
        };
        this.onSelect = this.onSelect.bind(this);
        this._changLable = this._changLable.bind(this);
    };

    // static defaultProps = {
    //     unusable: [{ "id": "33750188527", "desc": "所结算商品中没有符合条件的商品", "discount": 200, "endTime": 1523462399000, "beginTime": 1523462399000, "key": "0000-0337-5018-8577", "couponLimitInfo": "仅可购买自营奶粉尿裤玩具部分商品", "limitType": 1, "quota": 39.00, "type": 1 }, { "id": "33750188177", "desc": "所结算商品中没有符合条件的商品", "discount": 1200, "endTime": 1523462399000, "beginTime": 1523462399000, "key": "0000-0337-5018-8577", "couponLimitInfo": "仅可购买自营奶粉尿裤玩具部分商品", "limitType": 1, "quota": 39.00, "type": 0 }],
    //     usable: [{ "id": "33750188127", "desc": "所结算商品中没有符合条件的商品", "discount": 100, "endTime": 1523462399000, "beginTime": 1523462399000, "key": "0000-0337-5018-8577", "couponLimitInfo": "仅可购买自营奶粉尿裤玩具部分商品", "limitType": 1, "quota": 39.00, "type": 1 }, { "id": "3375188127", "desc": "所结算商品中没有符合条件的商品", "discount": 1200, "endTime": 1523462399000, "beginTime": 1523462399000, "key": "0000-0337-5018-8577", "couponLimitInfo": "仅可购买自营奶粉尿裤玩具部分商品", "limitType": 1, "quota": 39.00, "type": 1 }, { "id": "33752188177", "desc": "所结算商品中没有符合条件的商品", "discount": 1200, "endTime": 1523462399000, "beginTime": 1523462399000, "key": "0000-0337-5018-8577", "couponLimitInfo": "仅可购买自营奶粉尿裤玩具部分商品", "limitType": 1, "quota": 39.00, "type": 0 }, { "id": "33750118177", "desc": "所结算商品中没有符合条件的商品", "discount": 1600, "endTime": 1523462399000, "beginTime": 1523462399000, "key": "0000-0337-5018-8577", "couponLimitInfo": "仅可购买自营奶粉尿裤玩具部分商品", "limitType": 1, "quota": 39.00, "type": 0 }, { "id": "3370118177", "desc": "所结算商品中没有符合条件的商品", "discount": 1200, "endTime": 1523462399000, "beginTime": 1523462399000, "key": "0000-0337-5018-8577", "couponLimitInfo": "仅可购买自营奶粉尿裤玩具部分商品", "limitType": 1, "quota": 39.00, "type": 0 }, { "id": "337118177", "desc": "所结算商品中没有符合条件的商品", "discount": 3300, "endTime": 1523462399000, "beginTime": 1523462399000, "key": "0000-0337-5018-8577", "couponLimitInfo": "仅可购买自营奶粉尿裤玩具部分商品", "limitType": 1, "quota": 39.00, "type": 0 }]
    // }

    render() {
        const { unusable, usable, show, onHide, onAgree, coupon, iscan } = this.props;

        const { labelType, selectedCoupon } = this.state;

        return (
            <View style={ st.container }>

                {/* <Coupon_list list={couponList}/> */}

                <View style={ st.head }>
                    <View>
                        <JDText style={ st.title }>优惠券</JDText>
                    </View>
                    <JDTouchable onPress={ () => onHide() }>
                        <JDImage style={ st.close } source={ img.close } />
                    </JDTouchable>
                </View>

                <Change_tab type={ labelType } num={ [usable.length, unusable.length] } chang_lable={ this._changLable } />

                <JDScrollView style={ st.s_view } contentContainerStyle={ { maxHeight: pt(270) } } >

                    {
                        labelType == 1

                            /* 不可用列表 */
                            ? <Coupon_list_un list={ unusable } />
                            : usable.length > 0
                                /* 可用列表 */
                                ? usable.map((val) => {
                                    return (
                                        this.renderCategoryOption(val)
                                    );
                                })
                                :
                                /* 无优惠券 */
                                <NoCoupon iscan={ iscan } />
                    }

                    <View height={ pt(120) } />
                </JDScrollView>

                {
                    labelType == 0 && usable.length > 0 &&
                    <View style={ st.bottom }>
                        <JDTouchable contentContainerStyle={ st.btn } onPress={ () => onAgree(selectedCoupon) }>
                            <JDText style={ st.btn_txt }>确定</JDText>
                        </JDTouchable>
                    </View>
                }

            </View>
        );
    }

    componentDidMount() {
    }

    /* 修改tab */
    _changLable(arg) {
        // this.refs.scroll.scrollTo({x:0})
        this.setState({
            labelType: arg
        });
    }

    /* 选择优惠券 */
    onSelect(key, arg) {
        const { selectedCoupon } = this.state;
        const { fee } = this.props;

        // 是否当前已选择的券
        const inList = selectedCoupon.some((val, index) => {
            return (val.id == arg.id);
        });

        // 计算叠加优惠券总金额
        let discount = 0;

        selectedCoupon.forEach(val => {
            discount = discount + val.discount;
        });
        // 总金额大于实际金额
        if (discount >= fee && !inList) {
            tip('请先取消已勾选优惠券再进行选择');

            return;
        };

        const reg = [];
        // 清空当前选择券的列表

        if (inList) {
            selectedCoupon.forEach((val, index) => {
                if (val.id != arg.id) {
                    reg.push(val);
                }
            });
        }

        // 是否有东券
        const hasDcoupon = selectedCoupon.some((val, index) => {
            return (val.type == 1);
        });
        // 是否有京券

        const hasJcoupon = selectedCoupon.some((val, index) => {
            return (val.type == 0);
        });

        if (arg.type == 1) {
            // 列表有东券并点击的非当前选中的券
            if ((hasDcoupon || hasJcoupon) && !inList) {
                tip('请先取消已勾选优惠券再进行选择');

                return;
            };
        } else {
            // 列表有东券并点击的非当前选中的券
            if ((hasDcoupon) && !inList) {
                tip('请先取消已勾选优惠券再进行选择');

                return;
            };
        }

        const rsCoupon = inList ? reg : selectedCoupon.concat(arg);

        console.log(rsCoupon);
        this.setState({
            selectedCoupon: rsCoupon
        });
    }

    renderCategoryOption(val, index) {
        const { selectedCoupon } = this.state;
        const { fee } = this.props;

        const isSelected = selectedCoupon.some((item, index) => {
            return (val.id == item.id);
        });

        const hasDcoupon = selectedCoupon.some((item, index) => {
            return (item.type == 1);
        });

        const hasJcoupon = selectedCoupon.some((item, index) => {
            return (item.type == 0);
        });

        // 有已选东券  所有东券不可选 （type==1 为东券
        // 有已选东券 && 当前券为东券 && 未被选中  为false
        // isSelected = hasDcoupon ?  ((val.type == 1) && hasDcoupon && isSelected) : isSelected

        return (
            <JDTouchable onPress={ () => this.onSelect(selectedCoupon, val) }>
                <View style={ st.coupon_list }>
                    <Coupon_list val={ val } key={ '1' } selectedCoupon={ selectedCoupon } fee={ fee } hasDcoupon={ hasDcoupon } hasJcoupon={ hasJcoupon } isSelected={ isSelected } />
                </View>
            </JDTouchable>
        );
    }
}

class Coupon_list extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { val, isSelected, selectedCoupon, hasDcoupon, hasJcoupon, fee } = this.props;

        let backImage = val.type == 0 ? img.couponJ : img.couponD;

        let backColor = val.type == 0 ? st.couponj_tip : st.coupond_tip;

        if (hasDcoupon && !isSelected) {
            backImage = img.couponG;
            backColor = st.coupong_tip;
        }

        if (hasJcoupon && val.type != 0) {
            backImage = img.couponG;
            backColor = st.coupong_tip;
        }

        // 计算叠加优惠券总金额
        let discount = 0;

        selectedCoupon.forEach(val => {
            discount = discount + val.discount;
        });
        // 总金额大于实际金额
        if (discount >= fee && !isSelected) {
            backImage = img.couponG;
            backColor = st.coupong_tip;
        };

        return (
            <View style={ st.coupon }>
                <View style={ st.cou_left }>
                    <JDImage style={ st.left_img } source={ backImage }>
                        <View style={ st.p_text }>
                            <JDText style={ [st.l_txt, st.left_bs] }>&yen;</JDText>
                            <JDText style={ [st.l_txt, st.bigtxt] }>
                                {val.discount / 100}
                            </JDText>
                        </View>
                        <View style={ st.p_text }>
                            <JDText numberOfLines={ 1 } style={ st.l_txt }>
                                满{val.quota / 100}可用
                            </JDText>
                        </View>
                    </JDImage>
                </View>

                <View style={ st.cou_right }>
                    <View style={ st.title_txt }>
                        <View style={ backColor }>
                            <JDText style={ st.coupontxt }>
                                {val.type == 0 ? '京券' : '东券'}
                            </JDText>
                        </View>
                        <View style={ st.righttxt }>
                            <JDText style={ st.limit } numberOfLines={ 2 } >
                                {val.limitDesc || val.couponLimitInfo}
                            </JDText>
                        </View>
                    </View>
                    <JDText style={ st.endTime }>
                        {`${format(val.beginTime, '.')}- ${format(val.endTime, '.')}`}
                    </JDText>

                    <View style={ st.touse }>
                        <JDRadio unselectedIcon={ img.unselect } selected={ isSelected } style={ { marginRight: 10 } } />
                    </View>
                </View>

            </View>
        );
    }
}

class Coupon_list_un extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { list, isSelected } = this.props;

        const fillNum = list.length < 4 ? 4 : 8;

        return (
            list.length > 0
                ? <View style={ st.viewList }>

                    <View style={ st.coupon_list }>
                        {
                            list.map((val, index) => {
                                return (
                                    <View key={ index } style={ st.coupon }>

                                        <View style={ st.cou_left } >
                                            <JDImage style={ st.left_img } source={ val.type == 0 ? img.couponJ : img.couponD }>
                                                <View style={ st.p_text }>
                                                    <JDText style={ [st.l_txt, st.left_bs] }>&yen;</JDText>
                                                    <JDText style={ [st.l_txt, st.bigtxt] }>
                                                        {val.discount / 100}
                                                    </JDText>
                                                </View>
                                                <View style={ st.p_text }>
                                                    <JDText numberOfLines={ 1 } style={ st.l_txt }>
                                                        满{val.quota / 100}可用
                                                    </JDText>
                                                </View>
                                            </JDImage>
                                        </View>

                                        <View style={ st.cou_right }>
                                            <View style={ st.title_txt }>
                                                <View style={ val.type == 0 ? st.couponj_tip : st.coupond_tip }>
                                                    <JDText style={ st.coupontxt }>
                                                        {val.type == 0 ? '京券' : '东券'}
                                                    </JDText>
                                                </View>
                                                <View style={ st.righttxt }>
                                                    <JDText style={ st.limit } numberOfLines={ 2 } >
                                                        {val.limitDesc || val.couponLimitInfo}
                                                    </JDText>
                                                </View>
                                            </View>
                                            <JDText style={ st.endTime }>
                                                {`${format(val.beginTime, '.')}- ${format(val.endTime, '.')}`}
                                            </JDText>

                                            {/* <JDTouchable style={st.touse} onPress={()=>{toUse(type)}}>
                                        <View style={[st.touseview,val.type==0?st.touse_j:null]} >
                                            <JDText style={[st.touse_txt,val.type==0?st.touse_j_txt:null]}>立即使用</JDText>

                                        </View>

                                    </JDTouchable> */}
                                        </View>

                                    </View>
                                );
                            })
                        }
                    </View>
                </View>
                : <NoCoupon />
        );
    }
}

class Change_tab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            left: new Animated.Value(pt(this.props.type ? 244 : 43))
        };
    }

    render() {
        const { left } = this.state;
        const { type, chang_lable, num } = this.props;

        return (
            <View style={ st.change_tab }>
                <JDTouchable style={ [st.tabStart, st.changetab_left] } onPress={ () => {
                    chang_lable(0);
                    mta('OrdCouponCanUse', 'OrdInput');
                } }>
                    <JDText style={ [st.tab, type == 0 && st.selectTab] }>可用优惠券({num[0]})</JDText>
                </JDTouchable>
                <JDTouchable style={ [st.tabStart, st.changetab_right] } onPress={ () => {
                    chang_lable(1);
                    mta('OrdCouponNotUse', 'OrdInput');
                } }>
                    <JDText style={ [st.tab, type == 1 && st.selectTab] }>不可用优惠券({num[1]})</JDText>
                </JDTouchable>
                <Animated.View style={ [st.table_line, { left }] } />
                {/* <Animated.View style={[st.tabimg,{left}]}>
                <JDImage  source={img.Triangle}></JDImage>
                </Animated.View> */}
            </View>
        );
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.type != nextProps.type) {
            Animated.timing(this.state.left, {
                toValue: pt(nextProps.type == 0 ? 43 : 244),
                duration: 300
            }).start();
        }

        return true;
    }
}

class NoCoupon extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <View style={ st.no_coupon }>
                <JDImage style={ st.img_no } source={ img.no_coupon } />
                <JDText style={ st.no_text }>{this.props.iscan > 0 ? '很抱歉，当前优惠券暂不可使用' : '暂无优惠券'}</JDText>
            </View>
        );
    }
}

const img = {
    couponD: require('./img/couponD.png'),
    couponJ: require('./img/couponJ.png'),
    couponG: require('./img/couponG.png'),
    unselect: require('./img/select.png'),
    no_coupon: require('./img/no_coupon.png'),
    close: require('./img/close.png')
};

Coupon.contextTypes = {
    router: PropTypes.object
};
